import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../../requestOptions';
import type { ExpansionRun } from './types';

const validate = (runId: number, subscriptionId: number) => {
  if (!runId || runId < 1) {
    throw new Error('Valid run ID is required');
  }
  if (!subscriptionId || subscriptionId < 1) {
    throw new Error('Valid subscription ID is required');
  }
};

type RequestParams = {
  runId: number;
  /**
   * Any subscription of the organization — the API authorises the caller against it and scopes
   * every read by organization, never by this id.
   */
  subscriptionId: number;
};

export type CancelRunResponse = {
  run: ExpansionRun;
};

export const cancelRun = async (
  scope: RequestScope,
  { runId, subscriptionId }: RequestParams,
  options: WriteRequestOptions
): Promise<ChannelApiResponse<CancelRunResponse>> => {
  try {
    validate(runId, subscriptionId);

    const result = await scopedChannelApi(scope).post<CancelRunResponse>(
      `atts/expansion/runs/${runId}/cancel`,
      {},
      {
        ...options,
        headers: {
          'x-astur-subscription-id': subscriptionId.toString(),
        },
      }
    );

    return {
      data: result.data,
      status: result.status,
    };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
